import { IImages } from "../characters/Character"

export interface IinitAlly {
    initId: string
    initImg: IImages,
    initIcon: IImages
    initName: string
    initProfession: string
}

interface IAllyItem {
    amountToLevelUp: number,
    id: string,
    img: IImages,
    name: string
}

interface IAllyLevel {
    curruntLevel: number,
    maxLevel: number
}

export interface IAllyBountyValue {
    [level: number]: number
}

export interface IAllyBounty {
    name: string
    value: IAllyBountyValue
}

export class Ally {
    private img: IImages
    private icon: IImages
    private level: IAllyLevel
    private name: string
    private id: string
    private itemToLevelUp: IAllyItem
    private skill: string
    private profession: string
    private bounty: IAllyBounty
    private isActive: boolean
    private isFound: boolean

    constructor(init: IinitAlly) {
        this.img = init.initImg
        this.icon = init.initIcon
        this.name = init.initName
        this.profession = init.initProfession
        this.id = init.initId
        this.isActive = false
        this.level = {
            curruntLevel: 1,
            maxLevel: 40
        }
        this.itemToLevelUp = {
            id: "",
            img: { webp: "", img: "" },
            name: "",
            amountToLevelUp: 10
        }
        this.skill = "strength"
        this.bounty = { name: '', value: {} }
        this.isFound = false
    }

    getImg() {
        return this.img
    }

    getIcon() {
        return this.icon
    }

    getLevel() {
        return this.level
    }

    getName() {
        return this.name
    }

    getProfession() {
        return this.profession
    }

    getId() {
        return this.id
    }

    getItemToLevelUp() {
        return this.itemToLevelUp
    }

    setItemToLevelUp(newId: string, newName: string, newImg: IImages) {
        this.itemToLevelUp = {
            ...this.itemToLevelUp,
            id: newId,
            name: newName,
            img: newImg
        }
    }

    setBounty(newBounty: IAllyBounty) {
        this.bounty = newBounty
    }

    getBounty() {
        return this.bounty
    }

    addItemToLevelUp() {
        const newAmountToLevelUp = this.itemToLevelUp.amountToLevelUp + 10

        const newItem: IAllyItem = {
            ...this.itemToLevelUp,
            amountToLevelUp: newAmountToLevelUp
        }

        this.itemToLevelUp = newItem
        this.addLevel()
    }

    resetLevel() {
        this.level = {
            curruntLevel: 1,
            maxLevel: 40
        }
        this.itemToLevelUp = {
            ...this.itemToLevelUp,
            amountToLevelUp: 10
        }
    }

    private addLevel() {
        const newCurrentLevel = this.level.curruntLevel + 1
        const newLevel: IAllyLevel = {
            ...this.level,
            curruntLevel: newCurrentLevel
        }

        this.level = newLevel
    }

    getIsActive() {
        return this.isActive
    }

    setIsActive(value: boolean) {
        this.isActive = value
    }

    getIsFound() {
        return this.isFound
    }

    setIsFound(value: boolean) {
        this.isFound = value
    }
}